import { render, staticRenderFns } from "./config-master-item.vue?vue&type=template&id=d8fe6b54&scoped=true"
import script from "./config-master-item.vue?vue&type=script&lang=js"
export * from "./config-master-item.vue?vue&type=script&lang=js"
import style0 from "./config-master-item.vue?vue&type=style&index=0&id=d8fe6b54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8fe6b54",
  null
  
)

export default component.exports